import getFocusedInboxRollupStore from '../store/store';
import type InboxViewType from 'owa-service/lib/contract/InboxViewType';

const isValidRollupStore = () => {
    const { uniqueSenders, unseenCountToDisplay, viewType } = getFocusedInboxRollupStore();
    return !!uniqueSenders && !!unseenCountToDisplay && (viewType === 1 || viewType === 2);
};

export default isValidRollupStore;
